import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import iaqSensorDataChartType from '../types/iaqSensorDataChart.type';

export const getIAQSensorDataChart = (data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(getIAQSensorDataChartStart());
		let url = URLConstants.GetIAQIndexChartDataForSensor;
		services.post(url, data)
			.then(response => {
				dispatch(getIAQSensorDataChartSuccess(response.data));
			})
			.catch(err => {
				dispatch(getIAQSensorDataChartError(err));
			});
	};
};

const getIAQSensorDataChartStart = () => {
	return {
		type: iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_START
	};
};

const getIAQSensorDataChartSuccess = (data: any) => {
	return {
		type: iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_SUCCESS,
		payload: data
	};
};

const getIAQSensorDataChartError = (data: any) => {
	return {
		type: iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_ERROR,
		payload: data
	};
};

export const resetGetIAQSensorDataChartState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetIAQSensorDataChartDispatcher());
	};
};
export const resetGetIAQSensorDataChartSuccessState = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetGetIAQSensorDataChartSuccessDispatcher());
	};
};

const resetGetIAQSensorDataChartSuccessDispatcher = () => {
	return {
		type: iaqSensorDataChartType.RESET_IAQ_SENSOR_DATA_CHART_SUCCESS
	};
};
const resetGetIAQSensorDataChartDispatcher = () => {
	return {
		type: iaqSensorDataChartType.RESET_IAQ_SENSOR_DATA_CHART
	};
};